import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import axios from "axios";
import Image from '../Assets/print.gif'

const SupplierLedger = () => {
    const [gstFilter, setGstFilter] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [gstReport, setGstReport] = useState([]);
    const [originalGstReport, setOriginalGstReport] = useState([]); // Store all data
    const [uniqueGstRates, setUniqueGstRates] = useState([]);
    // const [selectedGst, setSelectedGst] = useState("18"); // Default GST rate
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [gstTotal, setGstTotal] = useState("");
    const [productTotal, setProductTotal] = useState("");
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        fetchGstReport();
    }, []);

    const fetchGstReport = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${API_BASE_URL}supplier_ledger_report.php`,
                { gst: "" }
            );

            if (response.data.head.code === 200) {
                setOriginalGstReport(response.data.body || []); // Store unfiltered data
                setGstReport(response.data.body || []); // Initially show all data
                setUniqueGstRates(response.data.body.list_of_gst);
                setGstTotal(response.data.body.gst_total);
                setProductTotal(response.data.body.product_total);
            } else {
                console.error("Error fetching data:", response.data.head.msg);
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        };
    };

    const handleFilter = (e) => {
        e.preventDefault();

        let filtered = [...originalGstReport];

        // Apply date filter if both dates are selected
        if (fromDate && toDate) {
            const from = new Date(fromDate);
            from.setHours(0, 0, 0, 0);

            const to = new Date(toDate);
            to.setHours(23, 59, 59, 999);

            filtered = gstReport.filter((item) => {
                if (!item.date) return false;

                const [day, month, year] = item.date.split("-");
                if (!day || !month || !year) return false;

                const formattedDate = new Date(`${year}-${month}-${day}`);
                formattedDate.setHours(0, 0, 0, 0);

                return formattedDate >= from && formattedDate <= to;
            });
        }

        // Apply GST filter
        if (gstFilter === "with") {
            filtered = filtered.filter((item) => parseFloat(item.gst_amt) > 0);
        } else if (gstFilter === "without") {
            filtered = filtered.filter((item) => parseFloat(item.gst_amt) === 0);
        }

        setGstReport(filtered);

        // Recalculate totals
        const newGstTotal = filtered.reduce((acc, item) => acc + parseFloat(item.gst_amt || 0), 0);
        const newProductTotal = filtered.reduce((acc, item) => acc + parseFloat(item.total || 0), 0);

        setGstTotal(newGstTotal.toFixed(2));
        setProductTotal(newProductTotal.toFixed(2));
    };
    let runningBalance = 0;

    const processedLedger = gstReport
        .sort((a, b) => {
            const [d1, m1, y1] = a.date.split("-");
            const [d2, m2, y2] = b.date.split("-");
            return new Date(y1, m1 - 1, d1) - new Date(y2, m2 - 1, d2);
        })
        .map((item) => {
            runningBalance =
                Number(runningBalance) +
                Number(item.debit || 0) -
                Number(item.credit || 0);

            return {
                ...item,
                balanceCalc: runningBalance
            };
        });

    // Calculate totals for footer
    const totals = processedLedger.reduce(
        (acc, item) => ({
            totalCredit: acc.totalCredit + Number(item.credit || 0),
            totalDebit: acc.totalDebit + Number(item.debit || 0),
        }),
        { totalCredit: 0, totalDebit: 0 }
    );

    // Closing balance = last row balance
    const closingBalance =
        processedLedger.length > 0
            ? processedLedger[processedLedger.length - 1].balanceCalc
            : 0;

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        // If empty → reset data
        if (!query) {
            setGstReport(originalGstReport);
            return;
        }

        const searchedOrders = originalGstReport.filter((item) => {
            return (
                item.supplier_name?.toLowerCase().includes(query) ||
                item.mobile?.includes(query) ||
                item.tax_number?.toLowerCase().includes(query)
            );
        });

        setGstReport(searchedOrders);
    };

    //   const handlePrint = () => {
    //     const fromDate = formatToDDMMYYYY(filters.startDate) || getMonthStartEnd().from_date;
    //     const toDate = formatToDDMMYYYY(filters.endDate) || getMonthStartEnd().to_date;

    //     console.log("Print From:", fromDate);
    //     console.log("Print To:", toDate);
    //     // /vinayaga_wires
    //     window.open(`/supplierledgerprint/${search}/${fromDate}/${toDate}`, '_blank');
    //   };
    const handlePrint = () => {
        const printWindow = window.open("", "_blank");

        const tableRows = processedLedger.map((item, index) => `
    <tr>
      <td>${gstReport.length - index}</td>
      <td>${item.date}</td>
      <td>${item.supplier_name}</td>
      <td style="text-align:right;">$ ${item.credit}</td>
      <td style="text-align:right;">$ ${item.debit}</td>
      <td style="text-align:right;">$ ${Math.abs(item.balanceCalc).toFixed(2)}</td>
    </tr>
  `).join("");

        printWindow.document.write(`
    <html>
      <head>
        <title>Supplier Ledger</title>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 8px; }
          th { background: #f2f2f2; }
        </style>
      </head>
      <body>
        <h2>Supplier Ledger</h2>
        <p><b>From:</b> ${fromDate || "-"} &nbsp;&nbsp; <b>To:</b> ${toDate || "-"}</p>
        <p><b>Search:</b> ${searchQuery || "All"}</p>

        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Customer</th>
              <th>Credit</th>
              <th>Debit</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.print();
    };

    return (
        <>
            <Header />
            <div className="page-wrapper compact-wrapper" id="pageWrapper">
                <div className="page-body-wrapper">
                    <div className="page-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card card-table">
                                        <div className="card-body">
                                            <div className="title-header option-title d-sm-flex d-block">
                                                <h5>Supplier Ledger</h5>
                                            </div>
                                            <div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <form className="theme-form theme-form-2 mega-form" onSubmit={handleFilter}>
                                                            <div className="mb-4 row align-items-center">

                                                                <label className="col-auto col-form-label form-label-title">
                                                                    From Date:
                                                                </label>
                                                                <div className="col-md-2">
                                                                    <input
                                                                        className="form-control"
                                                                        type="date"
                                                                        value={fromDate}
                                                                        onChange={(e) => setFromDate(e.target.value)}
                                                                    />
                                                                </div>
                                                                <label className="col-auto col-form-label form-label-title">
                                                                    To Date:
                                                                </label>
                                                                <div className="col-md-2">
                                                                    <input
                                                                        className="form-control"
                                                                        type="date"
                                                                        value={toDate}
                                                                        onChange={(e) => setToDate(e.target.value)}
                                                                    />
                                                                </div>
                                                                {/* Submit Button */}
                                                                <div className="col-md-2 d-flex justify-content-end">
                                                                    <button type="submit" className="btn btn-primary">
                                                                        Submit
                                                                    </button>
                                                                </div>

                                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                                    {/* Search Box */}
                                                                    <div className="col-md-6 col-sm-8">
                                                                        <form className="theme-form theme-form-2 mega-form">
                                                                            <div className="row align-items-center">
                                                                                <label
                                                                                    htmlFor="search"
                                                                                    className="col-sm-3 col-form-label"
                                                                                    style={{ fontSize: "14px" }}
                                                                                >
                                                                                    Search:
                                                                                </label>
                                                                                <div className="col-sm-9">
                                                                                    <input
                                                                                        type="text"
                                                                                        id="search"
                                                                                        name="search"
                                                                                        className="form-control"
                                                                                        placeholder="Search Product Name"
                                                                                        value={searchQuery}
                                                                                        onChange={handleSearch}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                        {/* <img src={Image} alt="Print" onClick={handlePrint} border="0" /> */}

                                                                    </div>

                                                                    <img src={Image} alt="Print" onClick={handlePrint} border="0" />
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>

                                                <div className="table-responsive">
                                                    {loading ? (
                                                        <div
                                                            className="d-flex justify-content-center align-items-center"
                                                            style={{ height: "200px" }}
                                                        >
                                                            <div
                                                                className="spinner-border text-primary"
                                                                style={{ width: "3rem", height: "3rem" }}
                                                                role="status"
                                                            >
                                                                <span className="visually-hidden">
                                                                    Loading...
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <table className="table all-package theme-table table-product">
                                                                <thead>
                                                                    <tr>
                                                                        <th>S.No.</th>
                                                                        {/* <th>Order ID</th> */}
                                                                        <th>Date</th>
                                                                        <th></th>
                                                                        <th>Supplier Name</th>
                                                                        {/* <th>Tax %</th> */}
                                                                        <th style={{ textAlign: "right" }}>Credit</th>
                                                                        <th style={{ textAlign: "right" }}>Debit</th>
                                                                        <th style={{ textAlign: "right" }}>Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {gstReport.length > 0 ? (
                                                                        // gstReport.map((item, index) => (
                                                                        processedLedger.map((item, index) => (
                                                                            <tr key={item.id}>
                                                                                <td>
                                                                                    {/* {index + 1} */}
                                                                                    {gstReport.length - index}
                                                                                </td>
                                                                                {/* <td>{item.order_id}</td> */}
                                                                                <td>{item.date}</td>
                                                                                <td></td>
                                                                                <td title={`Order ID: ${item.id}`}>{item.supplier_name}</td>

                                                                                {/* <td>{item.tax_percentage}%</td> */}
                                                                                <td style={{ textAlign: "right" }}>
                                                                                    $ {item.credit}
                                                                                </td>
                                                                                <td style={{ textAlign: "right" }}>
                                                                                    $ {item.debit}
                                                                                </td>
                                                                                <td style={{ textAlign: "right" }}>
                                                                                    {/* <i className="fas fa-dollar-sign"></i>  */}
                                                                                    {/* {item.balance} */}
                                                                                    <span className={item.balanceCalc >= 0 ? "text-danger" : "text-success"}>
                                                                                        $ {Math.abs(item.balanceCalc).toFixed(2)}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="7" className="text-center">
                                                                                No data available
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {/* Total Row */}
                                                                    {/* <tfoot> */}
                                                                    <tr className="fw-bold" style={{ background: "#f1f1f1" }}>
                                                                        <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>

                                                                        {/* Total Credit */}
                                                                        <td style={{ textAlign: "right", color: "green" }}>
                                                                            $ {totals.totalCredit.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                        </td>

                                                                        {/* Total Debit */}
                                                                        <td style={{ textAlign: "right", color: "red" }}>
                                                                            $ {totals.totalDebit.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                        </td>

                                                                        {/* Closing Balance */}
                                                                        <td style={{ textAlign: "right" }}>
                                                                            $ {Math.abs(closingBalance).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                            {closingBalance >= 0 ? " Dr" : " Cr"}
                                                                        </td>
                                                                    </tr>
                                                                    {/* </tfoot> */}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SupplierLedger;
